import { setCookie } from 'cookies-next';

export async function prelimsmock(data) {
    const response = await fetch(`https://admin.shankariasacademy.com/siaadminpanel/web/form/submit?formType=`+data.fields.formType, {
        method: 'POST',
        headers: {'Content-Type': 'application/json','Access-Control-Allow-Origin': '*'},
        body: JSON.stringify(data)
      })
      if (await !response.ok) {
        const message = `An error has occured: ${response.status}`;
      throw new Error(message);
    }
      const responseData=await response.json();
      setCookie('OtpToken', responseData.data[0].id,{secure: false,maxAge: 60 * 30,sameSite: "strict",path: "/"});
      return responseData;
}